<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
  >
    <template
      v-slot:activator="{ on }"
    >
      <!-- <v-btn
        dark
        small
        color="wrld_red"
        v-on="on"
      >
        {{ $t('shipments.quote') }}
      </v-btn> -->
      <div
      class="d-flex flex-column align-center"
      v-on="on"
      >
        <v-btn class="no-background-hover" :ripple="false" text height="30">
          <dollar-sign-icon
            class="quoting--icon"
          />
        </v-btn>
        <p
          class="mb-0 font-weight-medium quoting--text"
        >{{ $t('shipments.quote') }}</p>
      </div>
    </template>
    <v-card

    >
      <template
        v-if="getTransportCreatingShipmentState === 'loading'"
      >
        <v-card-text
          class="text-center pa-2"
        >
          <v-progress-circular
            :size="50"
            indeterminate
            color="wrld_black"
          ></v-progress-circular>
        </v-card-text>
      </template>
      <template
        v-else
      >
        <v-card-title
          class="headline"
        >
          {{ $t('transport_request.confirm_quote_order') }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="wrld_grey" @click="dialog = false">{{$t('buttons.reject')}}</v-btn>
          <v-btn color="wrld_red" dark @click="handleQuote">{{$t('buttons.accept')}}</v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'OrdersQuoting',
    props: {
      transport: {
        type: Object,
        default: () => null
      }
    },
    data() {
      return {
        dialog: false
      }
    },
    methods: {
      ...mapActions({
        quoteTransport: 'quoteTransport'
      }),
      handleQuote () {
        this.quoteTransport({ transportID: this.transport.objectID })
      }
    },
    computed: {
      ...mapGetters([
        'getTransportCreatingShipmentState'
      ])
    }
  }
</script>

<style lang="scss" scoped>
  .quoting--icon {
    width: 17px;
    height: 17px;
  }
  .quoting--text {
    font-size: 14px;
    cursor: pointer;
  }
</style>
